/** Shared offline/sync types — FE-12 persist + flush. */

export type OfflineCommandStatus = "Pending" | "Synced" | "Failed";

/** Actions that must never enter the Field offline queue. */
export const ONLINE_ONLY_ACTIONS = [
  "EXE_APPROVE",
  "QA_RELEASE",
  "VOID_POSTED",
] as const;

export type OfflineCommand = {
  id: string;
  actionType: string;
  label: string;
  status: OfflineCommandStatus;
  createdAt: string;
  syncedAt?: string;
  errorMessage?: string;
  /** JSON payload for flush handlers (operationId, complete input, …). */
  payload?: string;
};

export type SyncStatusSnapshot = {
  online: boolean;
  pendingCount: number;
  failedCount: number;
  syncedCount: number;
  lastSyncedAt: string | null;
};

export type EnqueueResult =
  | { ok: true; id: string }
  | { ok: false; message: string };

export type FlushResult = {
  ok: boolean;
  message?: string;
  synced: number;
  failed: number;
};
